import axios from 'axios';
import {
  loadPagesByBookId } from './../actions/entities/pages';

import { loadPlaceholdersByBookId } from './../actions/entities/placeholders';
import { loadBackgroundPlaceholderByBookId } from './../actions/entities/backgroundPlaceholders';
import {
  loadImagesByBookId,
} from './../actions/entities/images';
import {
  autofillFinished, imagesLoading,
} from './../actions/entities/io';
import { loadCoverDetailsByBookId } from './../actions/entities/cover';
import { loadBookBackgroundType, loadEditorBookProperties } from './../actions/ui/bookProperties';
import { loadAutoFill } from './../actions/ui/setAutoFill';
import { loadLayoutsByBookId } from './../actions/entities/layouts';

import {
  loadTextsByBookId,
} from './../actions/entities/texts';


import { loadPageToViewed } from './../actions/ui/addPageToViewed';

import {
  loadBookSizesByBookId,
  loadBookCoverByBookId,
  updateCoverMarginSize,
  loadPlaceholderBorderSize,
  loadBookContext,
  loadBabyBookStatus,
  loadBookDimensions,
} from './../actions/bookproperties';
import {
  getBookId,
  getDomain,
} from './../helpers/getParams';
import {
  configExist } from './../helpers';
import { imageChange } from '../actions/ui/imageChange';
import { isSavedBook } from '../actions/ui/isSavedBook';

const referer = getDomain();
const getStateUrl = configExist('getStateUrl', referer);
const url = `${getStateUrl}/${getBookId()}/editorjson`;

function loadBookPartials(json, dispatch, coverSize, isConverted = false) {
  const { entities, bookProperties, editorUI } = json;

  const placeholderBorderSize = bookProperties.placeholderBorderSize ? bookProperties.placeholderBorderSize : 0;

  // Book properties, pages, layouts and placeholders
  dispatch(loadBookSizesByBookId(bookProperties.bookSizes));
  dispatch(loadBookCoverByBookId(bookProperties.cover));
  dispatch(loadBookContext(bookProperties.context));
  dispatch(loadBookDimensions(bookProperties.dimensions));
  // Load baby book status if exist
  if (bookProperties.isBabyBook !== undefined) {
    dispatch(loadBabyBookStatus(bookProperties.isBabyBook));
  }

  dispatch(loadPlaceholderBorderSize(placeholderBorderSize));
  if (!isConverted) {
    dispatch(loadPagesByBookId(entities.pages));
  }
  dispatch(loadLayoutsByBookId(entities.layouts));
  dispatch(loadPlaceholdersByBookId(entities.placeholders));

  // load BackgroundPlaceholder if exist
  if (entities.backgroundPlaceholders !== undefined) {
    dispatch(loadBackgroundPlaceholderByBookId(entities.backgroundPlaceholders));
  }
  // load texts
  if (entities.texts) {
    dispatch(loadTextsByBookId(entities.texts));
  }

  // editorUI
  dispatch(loadBookBackgroundType(editorUI.bookProperties));
  dispatch(loadPageToViewed(editorUI.addPageToViewed));
  dispatch(loadAutoFill(editorUI.setAutoFill));
  dispatch(loadEditorBookProperties(editorUI.bookProperties));

  // Load images
  dispatch(loadImagesByBookId(entities.images));

  // Cover Details
  dispatch(loadCoverDetailsByBookId(entities.cover));

  if (!isConverted) {
    dispatch(autofillFinished(true));
  }
  dispatch(imageChange(false));

  // Temp for saved book
  const newPhotoCoverBook = Object.values(entities.layouts.byId).find(element => element.photoCoverLayoutVersion);
  if (newPhotoCoverBook !== undefined) {
    const photoCoverMargin = {
      left: 20,
      right: 20,
      top: 10,
      bottom: 10,
    };
    dispatch(updateCoverMarginSize(photoCoverMargin));
  }
  /*
    dispatch(updateCoverMarginSize(coverSize));
  */
  dispatch(isSavedBook(true));
}


export function loadBook(coverSize, store, lang) {
  return dispatch => axios
    .get(url, {
      withCredentials: true,
      mode: 'no-cors',
    })
    .then((repos) => {
      const { type } = store.getState().bookProperties.cover;
      const { type: newType, label: newlabel } = repos.data.json.bookProperties.cover;
      loadBookPartials(repos.data.json, dispatch, coverSize);
      dispatch(imagesLoading('loaded'));
    })
    .catch((err) => {
      throw err;
    });
}



// WEBPACK FOOTER //
// ./src/redux/helpers/loadBook.js